import router from "@/router/router";
import { useExplorerStore } from "@/modules/explorer/store";
import useDialog from "@/ui/composables/useDialog";

export function useAlertsRedirect() {
	const redirectBackToAlertsPage = async () => {
		const explorerStore = useExplorerStore();
		if (!explorerStore.explorerState.redirectToAlertsAfterSave) return;

		explorerStore.explorerState.redirectToAlertsAfterSave = false;

		const choice = await useDialog().confirm({
			title: "Alert saved",
			message:
				"The alert has been saved. Would you like to return to the alerts page?",
		});
		if (!choice) return;

		router.push({ name: "alerts.index" });
	};
	return {
		redirectBackToAlertsPage,
	};
}
